import GoogleMap from "../utils/map";
import ContactForm from "../modules/contact-form";

const Contacts = {
  map: null,

  init() {
    ContactForm.init();

    Contacts.copyProps();
    Contacts.renderMap();
  },

  copyProps() {
    //Copy one property to clipboard
    $(".properties-list__item").on("click", function () {
      var oneProperty = $(this)
        .find(".properties-list__item-value span")
        .text()
        .trim();
      copyText(oneProperty);

      const toggleNotice = () => {
        $(this).find(".notice").toggleClass("hidden");
      };
      toggleNotice();
      setTimeout(toggleNotice, 3500);
    });

    //Copy all properties to clipboard
    $(".properties-list__copy-all").on("click", function () {
      var allProperties = "";
      $(".properties-list")
        .find(".properties-list__item-name, .properties-list__item-value span")
        .each(function () {
          allProperties += $(this).text().trim() + "\n";
        });

      // console.log(allProperties);

      copyText(allProperties);

      const toggleNotice = () => {
        $(this).find(".notice").toggleClass("hidden");
      };
      toggleNotice();
      setTimeout(toggleNotice, 3500);
    });

    //Copy property URL to clipboard
    $(".properties-list__copy-link").on("click", function () {
      let url = $(this).data("url");
      copyText(url);

      const toggleNotice = () => {
        $(this).find(".notice").toggleClass("hidden");
      };
      toggleNotice();
      setTimeout(toggleNotice, 3500);
    });

    /**
     * Copy text to clipboard
     */
    function copyText(text) {
      const input = document.createElement("textarea");
      input.value = text;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
    }
  },

  renderMap() {
    const mapEl = $("#map-wrap");

    if (!mapEl.length) {
      return;
    }

    const markers = JSON.parse($("#markers").html());

    const data = {
      lat: 56.8761904,
      lng: 24.7239825,
      zoom: 10,
    };

    GoogleMap.create(data, mapEl, (map) => {
      const bounds = new GoogleMap.library.LatLngBounds();

      // Add markers to the map.
      for (let i = 0; i < markers.length; i++) {
        const location = markers[i];

        // fit markers
        bounds.extend(location);

        // Create marker.
        GoogleMap.addMarker(location);
      }

      // Fit markers
      map.fitBounds(bounds);
    });
  },
};

export default Contacts;
